import { render, staticRenderFns } from "./setMealAgentAllocation.vue?vue&type=template&id=573022d2&scoped=true&"
import script from "./setMealAgentAllocation.vue?vue&type=script&lang=js&"
export * from "./setMealAgentAllocation.vue?vue&type=script&lang=js&"
import style0 from "./setMealAgentAllocation.vue?vue&type=style&index=0&id=573022d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573022d2",
  null
  
)

export default component.exports